var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('v-btn',{staticStyle:{"margin":"0"},attrs:{"text":"","href":_vm.url,"target":"_blank","color":"primary"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("cloud_download")]),_vm._v(" "+_vm._s(_vm.$t('document_view.docBtn'))+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }